import { marked } from "marked";
import DOMPurify from "dompurify";

const SANITIZE_CONFIG = {
  ADD_ATTR: ["target", "rel"],
  ALLOWED_TAGS: [
    "p", "br", "hr", "b", "strong", "i", "em", "u", "s", "del", "mark", "sub", "sup",
    "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "pre", "code",
    "ul", "ol", "li", "a", "img", "table", "thead", "tbody", "tr", "th", "td",
    "span", "div",
  ],
  ALLOWED_ATTR: ["href", "src", "alt", "title", "class", "target", "rel"],
};

// Converts raw markdown or html into sanitized HTML, ready for dangerouslySetInnerHTML.
// MUST ALWAYS be used for user-generated content (forum posts, blog, signatures).
export function renderRichText(content, format = "markdown") {
  if (!content) return "";
  const rawHtml = format === "html" ? content : marked.parse(content, { breaks: true, gfm: true });
  return DOMPurify.sanitize(rawHtml, SANITIZE_CONFIG);
}
